import React, { useEffect, useState } from "react";
import { Package, Download, CheckCircle2, X, ShoppingCart } from "lucide-react";
import { Button } from "../ui/button";
import BookPayButton from "./BookPayButton";
import { fetchBookBundle, money, bookDownloadUrl } from "../../lib/api";

export const BundleOffer = () => {
  const [bundle, setBundle] = useState(null);
  const [buying, setBuying] = useState(false);
  const [downloadToken, setDownloadToken] = useState(null);

  useEffect(() => {
    fetchBookBundle().then(setBundle).catch(() => {});
  }, []);

  if (!bundle?.active) return null;

  return (
    <div className="bg-navy rounded-2xl shadow-lg p-6 sm:p-8 relative overflow-hidden" data-testid="bundle-offer">
      <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-gold/10 blur-3xl pointer-events-none" />
      <div className="grid md:grid-cols-[1fr_auto] gap-6 items-center relative">
        <div>
          <div className="inline-flex items-center gap-2 bg-gold text-navy px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide">
            <Package className="h-3.5 w-3.5" /> Best Value
          </div>
          <h3 className="font-serif text-white text-2xl sm:text-3xl font-bold mt-3">
            Get the Complete WOW Series
          </h3>
          <p className="text-gray-300 text-sm sm:text-base mt-2">
            All {bundle.book_count} books in one bundle — instant PDF downloads.
          </p>
          <div className="flex items-center gap-3 mt-3 flex-wrap">
            <span className="font-serif text-3xl font-bold text-gold" data-testid="bundle-price">{money(bundle.price)}</span>
            {bundle.savings > 0 && (
              <>
                <span className="text-gray-400 line-through">{money(bundle.regular_total)}</span>
                <span className="bg-green-500/20 text-green-300 text-xs font-semibold px-2.5 py-1 rounded-full">
                  Save {money(bundle.savings)}
                </span>
              </>
            )}
          </div>
        </div>
        <div className="flex -space-x-6 justify-center md:justify-end">
          {(bundle.covers || []).slice(0, 3).map((c, i) => (
            <img key={i} src={c} alt="" className={`h-28 sm:h-36 w-auto rounded shadow-xl ${i === 1 ? "z-10 -translate-y-2" : ""}`} />
          ))}
        </div>
      </div>

      <div className="mt-5 relative">
        {downloadToken ? (
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 space-y-3" data-testid="bundle-purchase-success">
            <div className="flex items-center gap-2 text-green-700 text-sm font-medium">
              <CheckCircle2 className="h-5 w-5" /> Bundle purchased — thank you!
            </div>
            <a href={bookDownloadUrl(downloadToken)} target="_blank" rel="noreferrer" data-testid="bundle-download-link">
              <Button className="w-full bg-navy hover:bg-navy-light text-white font-semibold">
                <Download className="h-4 w-4 mr-1.5" /> Download All Books (ZIP)
              </Button>
            </a>
            <p className="text-[11px] text-gray-500">Bookmark this link — you can re-download anytime.</p>
          </div>
        ) : buying ? (
          <div className="bg-white rounded-lg p-4 space-y-2">
            <BookPayButton bundle onPurchased={setDownloadToken} />
            <button
              onClick={() => setBuying(false)}
              className="w-full text-center text-xs text-gray-400 hover:text-navy flex items-center justify-center gap-1"
              data-testid="bundle-cancel-buy"
            >
              <X className="h-3 w-3" /> Cancel
            </button>
          </div>
        ) : (
          <Button
            onClick={() => setBuying(true)}
            className="w-full sm:w-auto bg-gold hover:bg-gold-dark text-navy font-semibold h-12 px-8 text-base"
            data-testid="bundle-buy-button"
          >
            <ShoppingCart className="h-4 w-4 mr-1.5" /> Buy the Bundle — {money(bundle.price)}
          </Button>
        )}
      </div>
    </div>
  );
};

export default BundleOffer;
